import { TransformWrapper, TransformComponent } from 'react-zoom-pan-pinch';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearchPlus, faSearchMinus } from '@fortawesome/free-solid-svg-icons';
import ElevationsNav from './ElevationsNav';
import { useContext } from 'react';
import { ModalContext } from '../contexts/ModalContext';
import elevations from '../helpers/elevations';

function ViewerTransformComponent(props) {
  if (props.isDesktop) {
    return (
      <TransformComponent>
        <div
          onClick={props.handleStoneClick}
          className="svg-elevation"
          dangerouslySetInnerHTML={{ __html: elevations(props.prefix) }}
        />
      </TransformComponent>
    );
  }

  return (
    <TransformComponent>
      <div
        onDoubleClick={props.handleStoneClick}
        className="svg-elevation"
        dangerouslySetInnerHTML={{ __html: elevations(props.prefix) }}
      />
    </TransformComponent>
  );
}

export default function Viewer(props) {
  const [, activateModal] = useContext(ModalContext);

  const handleStoneClick = (e) => {
    if (!e.target.classList.contains('svg-elevation')) {
      activateModal({
        selectedStone: e.target,
        disableBasket: props.disableBasket,
      });
    }
  };

  const isDesktop = () => {
    const navigatorAgent =
      navigator.userAgent || navigator.vendor || window.opera;

    const desktop = !(
      /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ipad|ip(hone|od|ad)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series([46])0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(
        navigatorAgent
      ) ||
      /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br([ev])w|bumb|bw-([nu])|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do([cp])o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly([-_])|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-([mpt])|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c([- _agpst])|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac([ \-/])|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja([tv])a|jbro|jemu|jigs|kddi|keji|kgt([ /])|klon|kpt |kwc-|kyo([ck])|le(no|xi)|lg( g|\/([klu])|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t([- ov])|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30([02])|n50([025])|n7(0([01])|10)|ne(([cm])-|on|tf|wf|wg|wt)|nok([6i])|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan([adt])|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c([-01])|47|mc|nd|ri)|sgh-|shar|sie([-m])|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel([im])|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c([- ])|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(
        navigatorAgent.substr(0, 4)
      )
    );
    const notIPad = !window.matchMedia('(pointer: coarse)').matches;

    return desktop && notIPad ? true : false;
  };

  const userInstructions = isDesktop()
    ? 'Zoom in and click on a stone to select it '
    : 'Zoom in and double tap to select a stone';

  return (
    <TransformWrapper
      options={{ maxScale: 20 }}
      doubleClick={{ disabled: true }}
    >
      {({ zoomIn, zoomOut, resetTransform, ...rest }) => (
        <div className="viewer">
          <div className="text-center">
            <div className="row mx-0">
              <div className="col-lg-6 order-lg-1 px-0 mb-3">
                <div className="bg-white h-100 py-2 px-3">
                  <div className="w-75 mx-auto">
                    <p className="mb-2">
                      <small>You are viewing the</small>
                    </p>

                    <ElevationsNav prefix={props.prefix} slug={props.slug} />
                  </div>
                </div>
              </div>

              <div className="col-lg-6 order-lg-0 px-0 mb-3">
                <div className="bg-white h-100 py-2 px-3">
                  <p className="d-none d-md-block mb-0">
                    <small>Use magnifying glass to zoom in and out</small>
                  </p>

                  <div className="d-flex justify-content-center">
                    <button
                      onClick={zoomIn}
                      className="btn mx-1"
                      style={{ fontSize: '1.4rem' }}
                    >
                      <FontAwesomeIcon icon={faSearchPlus} />
                    </button>

                    <button
                      onClick={zoomOut}
                      className="btn px-2 mx-1"
                      style={{ fontSize: '1.4rem' }}
                    >
                      <FontAwesomeIcon icon={faSearchMinus} />
                    </button>

                    <button
                      onClick={resetTransform}
                      className="btn px-3 mx-1"
                      style={{ fontSize: '1.3rem' }}
                    >
                      Reset
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="text-center mobile-message">
            <h5>{userInstructions}</h5>
            <p>
              Dark grey stones have already been sponsored
            </p>
          </div>

          <div className="viewer__svg bg-white">
            <ViewerTransformComponent
              prefix={props.prefix}
              handleStoneClick={handleStoneClick}
              isDesktop={isDesktop()}
            />
          </div>
        </div>
      )}
    </TransformWrapper>
  );
}
